export default __webpack_public_path__ + "static/media/sadi.4659edd4.jpg";